import { render, staticRenderFns } from "./IncidentTypesModal.vue?vue&type=template&id=7d1348d4&scoped=true"
import script from "./IncidentTypesModal.vue?vue&type=script&lang=js"
export * from "./IncidentTypesModal.vue?vue&type=script&lang=js"
import style0 from "./IncidentTypesModal.vue?vue&type=style&index=0&id=7d1348d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1348d4",
  null
  
)

export default component.exports